<template>
  <div class="book-chapter-content d-book-chapter font-size-large space-top-2em">
    <div
      class="content"
      :class="{
        'blurred': (containExplicit && contentIsHidden),
      }"
    >
      <slot name="chapter" />
    </div>

    <DExplicitOverlay
      v-if="(containExplicit && contentIsHidden)"
      button-text="Read preview"
      class="explicit-overlay"
      @button-click="showContent"
    />
  </div>
</template>

<script>
import DExplicitOverlay from '@d-components/d-explicit-overlay/d-explicit-overlay.vue';

export default {
  components: {
    DExplicitOverlay,
  },
  props: {
    containExplicit: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    contentIsHidden() {
      return this.$store.getters['ExplicitContent/get-hidden-content'].chapter;
    },
  },
  methods: {
    showContent() {
      this.$store.dispatch('ExplicitContent/setChapterVisibility', false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-book-chapter {
  position: relative;

  .content.blurred {
    $content-height: $_10em * 3;

    filter: blur($_0-5em);
    min-height: $content-height;

    &::after {
      background-color: getColor($translucent, dark);
      bottom: 0;
      content: '';
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .explicit-overlay {
    position: absolute;
    top: $_2em;
  }
}
</style>

